// ─── Phone number ─────────────────────────────────────────────────────────────
// Accepted formats: (416) 555-0100 | 416-555-0100 | 416.555.0100 | 4165550100
// With optional +1 country code

const PHONE_REGEX = /^(\+?1[\s.-]?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

/**
 * Auto-formats a phone number string as (XXX) XXX-XXXX while the user types.
 * Strip everything, then re-insert the mask up to 10 digits.
 */
export const formatPhoneNumber = (value: string): string => {
  const digits = value.replace(/\D/g, "").slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};

// ─── Email ────────────────────────────────────────────────────────────────────
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// ─── Optional validators (field not required) ─────────────────────────────────
export const validateEmail = (value: string): string | undefined => {
  if (value && !EMAIL_REGEX.test(value)) return "Invalid email address.";
  return undefined;
};

export const validatePhoneNumber = (value: string): string | undefined => {
  if (value && !PHONE_REGEX.test(value))
    return "Enter a valid phone number, e.g. (416) 555-0100";
  return undefined;
};

// ─── Required validators ──────────────────────────────────────────────────────
export const requiredValidateEmail = (value: string): string | undefined => {
  if (!value) return "Email is required.";
  if (!EMAIL_REGEX.test(value)) return "Invalid email address.";
  return undefined;
};

export const requiredValidatePhoneNumber = (value: string): string | undefined => {
  if (!value) return "Phone number is required.";
  if (!PHONE_REGEX.test(value)) return "Enter a valid phone number, e.g. (416) 555-0100";
  return undefined;
};
